import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Products, company, followUs, list, support } from "./constants";
import { useNavigate, useLocation } from "react-router-dom";
import { getLeads } from "../../redux/actions/userSubscription";
import { validPaths } from "../../common/constants";

const Footer = () => {
  const [courses, setCourses] = useState([]);
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const role_type = useSelector((store) => store?.useSubscription?.role_type);
  const all_courses = useSelector((store) => store?.courses?.allCourses);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setCourses(all_courses);
  }, []);

  const handleRoute = (link) => {
    window.open(link);
  };

  const handleNavigation = (link) => {
    navigate(`/${link}`, { target: "_blank" });
  };

  const customStyle = {
    gridColumn: "span 1.5",
  };

  return location.pathname !== "/login" &&
    location.pathname !== "/player-gateway" &&
    !location.pathname.startsWith("/personalise") &&
    location.pathname !== "/pricing" &&
    location.pathname !== "/verification" &&
    !location.pathname.includes("/verify/certificate") &&
    location.pathname !== "/" &&
    location.pathname !== "/knowledge-graph" &&
    location.pathname !== "/hackathon" &&
    location.pathname !== "/onboarding" &&
    location.pathname !== "/onboarding/loader" &&
    !validPaths.includes(location.pathname) &&
    location.pathname !== "/onboarding/analysis" &&
    location.pathname !== "/set-password" &&
    location.pathname !== "/halloffame/" &&
    !location.pathname.includes("/halloffame/") &&
    location.pathname !== "/recruiter" &&
    location.pathname !== "/recruiter/" &&
    location.pathname !== "/recruiter/results" &&
    location.pathname !== "/recruiter/profile" &&
    location.pathname !== "/recruiter/signup" &&
    location.pathname !== "/leaderboard" ? (
    <div className="flex  flex-col bg-[#061016] py-5 text-white md:flex-row lg:py-10">
      <div className="flex flex-col items-center md:ml-10 md:mr-3 md:w-[28%] md:items-start lg:mr-0 lg:ml-16">
        <div className="flex flex-col items-center md:items-start ">
          <div className="mb-3 flex items-center justify-center gap-2">
            <div className="flex flex-col items-center justify-center">
              <div
                className="flex w-fit items-center  gap-2 rounded-md"
                onClick={() => navigate("/courses")}
              >
                <img
                  alt="a green and blue play button on a black background"
                  src="https://img.learntube.ai/public-assets/post-payment-updates/image%2011.svg?updatedAt=1728356261811"
                  loading="eager"
                  className="h-[42px] w-[42px]"
                />
                <p className="text-xl font-semibold">LearnTube.ai</p>
              </div>
              <p className="mt-2 text-xs  font-normal tracking-wide md:mt-4 ">
                Copyrights 2026 CareerNinja
              </p>
            </div>
            <div className="h-full w-[160px] border-l-2 border-[#797979] md:w-[210px]">
              <img
                alt="a black and white logo with the words developed with youtube"
                src="https://developers.google.com/static/youtube/images/developed-with-youtube-sentence-case-light.png"
                className=" h-full w-full object-cover"
              ></img>
            </div>
          </div>

          <button
            onClick={() => {
              dispatch(
                getLeads({
                  user_id: user_id ? user_id : 0,
                  user_plan: role_type ? role_type : "basic",
                  product_id: 3,
                  product_name: "LearnTubeX",
                  product_type: "subscription",
                  is_visit: false,
                }),
              );
              navigate("/pricing");
            }}
            className="flex items-center justify-center rounded bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-600 px-5 py-[10px] text-center text-lg font-bold text-black shadow-md transition duration-150 ease-in-out hover:bg-orange-400 hover:text-white hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:bg-yellow-400 active:shadow-lg lg:hidden"
          >
            <div className="mr-3 h-6 w-6 md:h-8 md:w-8">
              <img
                className=" h-full w-full rounded-full"
                alt="coin icon"
                src="https://img.learntube.ai/public-assets/skill_page/pro.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660918183860"
              />
            </div>
            Upgrade To Pro
          </button>
          <p className="my-4 w-[90%] text-center text-sm font-normal md:text-left lg:mt-0">
            LearnTube is India’s first AI-driven Ed Tech Platform where you’ll
            find 300+ courses and 900+ Hiring partners under 1 platform.
          </p>
          <button
            onClick={() => {
              dispatch(
                getLeads({
                  user_id: user_id ? user_id : 0,
                  user_plan: role_type ? role_type : "basic",
                  product_id: 3,
                  product_name: "LearnTubeX",
                  product_type: "subscription",
                  is_visit: false,
                }),
              );
              navigate("/pricing");
            }}
            className="hidden items-center justify-center rounded bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-600 px-5 py-[10px] text-center text-lg font-bold text-black shadow-md transition duration-150 ease-in-out hover:bg-orange-400 hover:text-white hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:bg-yellow-400 active:shadow-lg lg:flex"
          >
            <div className="mr-3 h-6 w-6 md:h-8 md:w-8">
              <img
                className=" h-full w-full rounded-full"
                alt="coin icon"
                src="https://img.learntube.ai/public-assets/skill_page/pro.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660918183860"
              />
            </div>
            Upgrade To Pro
          </button>
        </div>
        <div>
          <p className="mb-2 mt-1 text-center md:text-left lg:mt-5 lg:mb-2">
            Download our app now!
          </p>
          <div
            className="w-[13rem]  cursor-pointer"
            onClick={() => {
              window.open(
                "https://play.google.com/store/apps/details?id=com.learntube",
              );
            }}
          >
            <img
              alt="a sign that says get on google play"
              src="https://storage.googleapis.com/learntube-web-assets/files/Optimized_LandingPagev3/google-play-badge__1__webp.png"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
        <div className="my-4 flex h-[4.6rem] w-[17rem] items-center rounded-xl border py-1 pl-3 pr-4 md:w-[16rem] lg:w-[17rem]">
          <div className="mr-2 h-[45px] w-[45px] rounded-full bg-white">
            <img
              alt="a white circle with the google logo on it"
              src="https://img.learntube.ai/public-assets/About-us/unnamed.webp?updatedAt=1685425840630"
              className="h-full w-full rounded-full object-center"
            />
          </div>
          <div className="flex-1 pr-2 md:pr-1 lg:pr-2">
            <p className="pl-2 text-xs font-medium tracking-wider">
              Google Reviews
            </p>
            <div className="flex items-center justify-evenly">
              <p className="text-lg font-bold">4.7</p>
              <div>
                <img
                  src="https://img.learntube.ai/public-assets/About-us/Star_6.svg?updatedAt=1685425989505"
                  alt="star icon"
                />
              </div>
              <div>
                <img
                  src="https://img.learntube.ai/public-assets/About-us/Star_6.svg?updatedAt=1685425989505"
                  alt="star icon"
                />
              </div>
              <div>
                <img
                  src="https://img.learntube.ai/public-assets/About-us/Star_6.svg?updatedAt=1685425989505"
                  alt="star icon"
                />
              </div>
              <div>
                <img
                  src="https://img.learntube.ai/public-assets/About-us/Star_6.svg?updatedAt=1685425989505"
                  alt="star icon"
                />
              </div>
              <div>
                <img
                  src="https://img.learntube.ai/public-assets/About-us/Star_10.svg?updatedAt=1685425942166"
                  alt="star icon"
                />
              </div>
            </div>
            <p className="pl-2 text-xs tracking-wider opacity-70">
              Based on 388 reviews
            </p>
          </div>
        </div>
        <div className="mt-2 flex gap-1">
          <div className="h-[102px] w-[89px]">
            <img
              alt="the logo for the 2012 gvs cup"
              src="https://img.learntube.ai/public-assets/About-us/gsv.png?updatedAt=1687163269620"
              className="h-full w-full object-fill "
            />
          </div>
          <div className="ml-1 mr-1 h-[102px] w-[89px]">
            <img
              alt="the logo for top 10 in EdTech"
              src="https://img.learntube.ai/public-assets/About-us/Group_6957.svg?updatedAt=1685426177243"
              className="h-full w-full object-fill "
            />
          </div>
          <div className=" h-[102px] w-[89px]">
            <img
              alt="a red and white logo with the words,'illustious start up of"
              src="https://img.learntube.ai/public-assets/About-us/Group_8565.png?updatedAt=1687162559097"
              className="h-full w-full object-fill "
            />
          </div>
        </div>
      </div>
      <div className="mt-10 grid grid-cols-2 pl-6 pr-3 md:mt-0 md:flex-1 md:grid-cols-3 md:grid-rows-2 lg:grid-cols-5 lg:grid-rows-1 lg:pl-12">
        <div className="h-auto">
          <p className="mb-5 text-base font-semibold">Company</p>
          <ul className="flex flex-col text-sm opacity-70">
            {company.map((item) => (
              <li key={item.id} className="mb-3">
                <span
                  className="cursor-pointer"
                  onClick={() => handleRoute(item.link)}
                >
                  {item.name}
                </span>
              </li>
            ))}
          </ul>
        </div>
        <div className="hidden h-auto lg:block">
          <p className="mb-5 text-base font-semibold">Courses</p>
          <ul className="flex flex-col text-sm opacity-70">
            {courses?.map((item) => (
              <li key={item?.id} className="mb-3">
                <span
                  className="cursor-pointer"
                  onClick={() => handleNavigation(item?.course_slug)}
                >
                  {item?.["course-name"]}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div className="h-auto lg:ml-3">
          <p className="mb-5 text-base font-semibold">Follow Us</p>
          <ul className="flex flex-col text-sm opacity-70">
            {followUs.map((item) => (
              <li key={item.id} className="mb-3">
                <span
                  className="cursor-pointer"
                  onClick={() => handleRoute(item.link)}
                >
                  {item?.name}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-3 h-auto md:mt-0">
          <p className="mb-5 text-base font-semibold">Support</p>
          <ul className="flex flex-col text-sm opacity-70">
            {support.map((item) => (
              <li key={item.id} className="mb-3 w-auto">
                <span
                  className="cursor-pointer"
                  onClick={() => handleRoute(item.link)}
                >
                  {item?.name}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-3 h-auto md:mt-0">
          <p className="mb-5 text-base font-semibold">Products</p>
          <ul className="flex flex-col text-sm opacity-70">
            {Products.map((item) => (
              <li key={item.id} className="mb-3">
                <span
                  className="cursor-pointer"
                  onClick={() => handleRoute(item.link)}
                >
                  {item?.name}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  ) : null;
};

export default Footer;
